import { stdObject } from "../../../data/types/stdObject";

export const getTaxList = (value: number, getTaxList: Array<stdObject>) => {
  let taxExists = Object.values(getTaxList).some(
    (e: any) =>
      ["string", "number"].includes(typeof value) && e.TARIMP === Number(value),
  );
  let totalTaxes = getTaxList.map((e: stdObject) => {
    return { label: `${e.TARIMP}%`, value: e.TARIMP };
  });

  return taxExists
    ? totalTaxes
    : [
        {
          label: value + "%",
          value: value,
        },
        ...totalTaxes,
      ];
};
